import React from "react"
import {RouteComponentProps} from "react-router"
import {useTranslation} from "react-i18next"

import {usePersonGroups as useItems} from "../../contexts/PersonGroupContext"

import ItemForm from "../../components/PersonGroups/Form"
import ItemView from "../../components/PersonGroups/View"
import PageItem from "../common/Item"
import NotFound from "../../components/PersonGroups/NotFound"
import LockingSystemPermissionsList from "../../components/PersonGroups/PersonGroupLockingSystemPermissions/List";
import PeopleList from "../../components/PersonGroups/PersonGroupPeople/List";

interface pageProps extends RouteComponentProps<{
    id:      string;
    segment: string;
}> {}

const PagePersonGroupsItem: React.FC<pageProps> = ({ match }) => {
    const { t }        = useTranslation()
    const { fetchItems, items} = useItems()

    const
        itemType:     string = 'PersonGroup',
        itemTypeName: string = t('person-groups.title_item'),
        itemTypeUrl:  string = 'person-groups'

    return (
        <PageItem
            useItems={useItems}
            fetchItems={fetchItems}
            itemId={match.params.id}
            items={items}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            ItemForm={ItemForm}
            ItemNotFound={NotFound}
            ItemView={ItemView}
            LockingSystemPermissionsList={LockingSystemPermissionsList}
            PeopleList={PeopleList}
            segment={match.params.segment}
        />
    )
}

export default PagePersonGroupsItem